(function () {
   'use strict';

   var logger = new (require('../helpers/logger.js'))("Image Initializer").setColor("#212157");
   var helper = require('../helpers/generic.js');
   var ACClient = require('../AssetCore/client.js');
   var jquery = require('jquery');

   module.exports = {
     bgImageFromData: bgImageFromData,
     imageFromData: imageFromData
  };

  function inheritMaxWidth($element, selector, media){
    function checkSizeAndApply($element, media, enlarge){
      var elWidth = $elForInheritation.width();
      var ratio = media.ratio();
      var height = elWidth / ratio;
      if (elWidth > 0 && !isNaN(ratio) && ((height <= media.height() && elWidth <= media.width()) || enlarge)){
        applySize($element, elWidth, height);
        //logger.debug("applied "+elWidth+"x"+height+" on element", $element);
      } else {
        applySize($element, media.width(), media.height());
        //logger.debug("applied original media dimensions on element", $element);
      }
    }
    function applySize($element, width, height){
      if (!helper.undefOrNull($element.data("asset"))){ //image
        $element.attr("width", width);
        $element.attr("height", height);
      } else { //background-image (bgAsset)
        $element.css({
          width: width,
          height: height
        });
      }
    }
    var $elForInheritation = $(selector);
    if (helper.undefOrNull($elForInheritation)){
      logger.debug("wont' inherit container width as $elForInheritation with selector ("+selector+") was not found");
    } else {
      $(window).on('resize', function(){ checkSizeAndApply($element, media, false); });
      checkSizeAndApply($element, media, false);
    }
  }



  function bgImageFromData($el){
    var deferred = jquery.Deferred();

    var code = $el.data("bgAsset");
    var inheritMaxWidthFrom = $el.data("inheritMaxWidthFrom");
    lazyInitClient().detailsForCode(code).done(function(media){
      $el.css({
        backgroundImage: 'url("'+media.dppxUrl()+'")',
        backgroundPosition: 'center center',
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        width: media.width()+'px ',
        height: media.height() + 'px '
      });
      if(!helper.undefOrNull(inheritMaxWidthFrom)){
        inheritMaxWidth($el, inheritMaxWidthFrom, media);
      }
      deferred.resolve($el, media);
    }).fail(function(){
      logger.error("ACClient: Error fetching media data for code '"+code+"'");
      deferred.reject();
    });

    return deferred.promise();
  }

  function imageFromData($img){
    var deferred = jquery.Deferred();
    var code = $img.data("asset");
    var inheritMaxWidthFrom = $img.data("inheritMaxWidthFrom");
    lazyInitClient().detailsForCode(code).done(function(media){
      $img.attr('src', media.dppxUrl());
      if (!$img.attr('width') && !$img.attr('height')){
        $img.attr('width', media.width());
        $img.attr('height', media.height());
      }
      if(!helper.undefOrNull(inheritMaxWidthFrom)){
        inheritMaxWidth($img, inheritMaxWidthFrom, media);
      }
      deferred.resolve($img, media);
    }).fail(function(){
      logger.error("ACClient: Error fetching media data for code '"+code+"'");
      deferred.reject();
    });

    return deferred.promise();
  }

  var client = null;
  function lazyInitClient(){
    if (helper.undefOrNull(client)){
      client = new ACClient();
    }
    return client;
  }

}());



//////////////////
// WEBPACK FOOTER
// ./src/helpers/imageInitializers.js
// module id = 33
// module chunks = 0